import {Box} from '@chakra-ui/react';
import {ContextType, FC, PropsWithChildren, useContext} from 'react';
import {VisibilityContext} from 'react-horizontal-scrolling-menu';

type Props = {
  itemId: string;
  onClick: (visibility: ContextType<typeof VisibilityContext>) => void;
};

export const CategoryCardWrapper: FC<PropsWithChildren<Props>> = ({itemId, onClick, children}) => {
  const visibility = useContext(VisibilityContext);

  return (
    <Box
      as="button"
      onClick={() => onClick(visibility)} // NOTE: for center items
      tabIndex={0}
      key={itemId}
      mr="6px"
    >
      {children}
    </Box>
  );
};
